import React from 'react';
import { Form, Input } from 'antd';
import { ErrorMessage, SwitchCommon, InputCommon, PrefixedInput } from 'components/common';
import { BrandInfoSectionProps } from 'types';

const BrandInfoSection: React.FC<BrandInfoSectionProps> = ({
  form,
  onGenerate,
  isActive,
  editMode,
  setIsActive,
  onSubmit,
  codePrefix = '',
  isCopyMode = false,
  setCodePrefix = () => {},
}) => {
  const handleToggleActive = (checked: boolean) => {
    setIsActive(checked);
    form.setFieldValue('isActive', checked);
  };

  return (
    <div className='col-span-5 p-5 bg-white rounded-md shadow-sm'>
      <h3 className='text-[20px] leading-[24px] font-bold mb-4'>Thông tin thương hiệu</h3>

      <Form form={form} layout='vertical' className='!mt-2 !pl-1' onFinish={onSubmit} requiredMark={false}>
        <Form.Item
          name='name'
          label={
            <span className='relative text-[14px] leading-[20px]'>
              Tên thương hiệu
              <span className='absolute -top-1 -right-3 text-red-500 text-[8px] font-medium'>✱</span>
            </span>
          }
          rules={[
            {
              required: true,

              message: <ErrorMessage message='Giá trị này là bắt buộc, bạn phải nhập giá trị!' />,
            },
            {
              max: 100,
              message: <ErrorMessage message='Tên thương hiệu không được quá 100 ký tự!' />,
            },
          ]}
        >
          <InputCommon
            className='!border-0 !pl-0 rounded-none font-bold !text-[20px] !leading-[24px] !border-b-[1px] border-[var(--textBlack12)] !transition-none !shadow-none'
            placeholder='Nhập vào tên thương hiệu'
            radius='none'
            maxLength={100}
          />
        </Form.Item>

        <Form.Item
          name='code'
          label={
            <span className='relative text-[14px] leading-[20px]'>
              Mã thương hiệu
              <span className='absolute -top-1 -right-3 text-red-500 text-[8px] font-medium'>✱</span>
            </span>
          }
          rules={[
            {
              required: true,
              message: <ErrorMessage message='Giá trị này là bắt buộc, bạn phải nhập giá trị!' />,
            },
            {
              max: 12,
              message: <ErrorMessage message='Mã thương hiệu không được quá 12 ký tự!' />,
            },
          ]}
        >
          <PrefixedInput
            prefix={codePrefix}
            maxEditableLength={6}
            placeholder='Nhập mã'
            disabled={editMode && !isCopyMode}
            className='!text-[14px] !leading-[20px] '
            inputProps={{
              suffix: (!editMode || isCopyMode) && (
                <span
                  className='text-[var(--primaryColor500)] cursor-pointer'
                  onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (onGenerate) {
                      try {
                        const code = await onGenerate();
                        if (code && code.length >= 6) {
                          setCodePrefix(code.substring(0, 6));
                          form.setFieldsValue({ code });
                        }
                      } catch (error) {
                        console.error('Error generating code:', error);
                      }
                    }
                  }}
                >
                  Generate
                </span>
              ),
              // hardSize: 'sm',
            }}
          />
        </Form.Item>

        <Form.Item name='isActive' valuePropName='checked' initialValue={true}>
          <SwitchCommon
            label={isActive ? 'Kích hoạt' : 'Chưa kích hoạt'}
            isActive={isActive}
            onChange={handleToggleActive}
            disabled={editMode}
          />
        </Form.Item>

        <Form.Item
          name='description'
          rules={[
            {
              max: 1000,
              message: <ErrorMessage message='Mô tả không được quá 1000 ký tự!' />,
            },
          ]}
          label={<span className='text-[14px] leading-[20px]'>Mô tả thương hiệu</span>}
        >
          <Input.TextArea
            rows={6}
            maxLength={1000}
            showCount
            placeholder='Nhập mô tả'
            className='resize-none'
            style={{ height: '160px' }}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default BrandInfoSection;
